import { useState } from "react";

interface AddNoteModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSave: (note: string) => void;
}

const AddNoteModal = ({ isOpen, onCancel, onSave }: AddNoteModalProps) => {
  const [note, setNote] = useState("");

  const handleSave = () => {
    onSave(note);
    setNote("");
  };

  const handleCancel = () => {
    setNote("");
    onCancel();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="rounded-lg shadow-lg w-[550px]" style={{ backgroundColor: '#1A2B47' }}>
        <div className="px-6 py-4 border-b border-gray-600">
          <h3 className="text-lg font-semibold text-white">Add Note</h3>
        </div>
        
        <div className="px-6 py-4">
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="w-full h-[200px] p-3 border border-gray-600 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white"
            style={{ backgroundColor: '#111E33' }}
            placeholder="Enter your note here..."
          />
        </div>
        
        <div className="px-6 py-4 border-t border-gray-600 flex justify-end gap-3">
          <button
            onClick={handleCancel}
            className="px-4 py-2 text-gray-300 bg-gray-700 hover:bg-gray-600 rounded-md transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNoteModal;